import Cookie from '../../components/cookies';

function setLayout(layout) {
  const layouts_arr = [1, 2, 4];
  const $productGrid = $('#product-grid');
  layouts_arr.forEach((view) => {
    $productGrid.removeClass(`grid--${view}-col-tablet-down`);
    $productGrid.removeClass(`grid--${view}-col-desktop`);
  });

  $productGrid.addClass(`grid--${layout}-col-tablet-down`);
  $productGrid.addClass(`grid--${layout}-col-desktop`);
}

function handleResponsive() {
  const breakpoint = window.matchMedia('(max-width: 767px)');

  breakpoint.addEventListener('change', (event) => {
    const cookie = new Cookie();
    const saveLayout =
      cookie.getCookie('grid-layout') != undefined
        ? parseInt(cookie.getCookie('grid-layout'))
        : null;

    if (saveLayout != null) {
      handleBreakpoints(breakpoint, saveLayout);
    } else {
      handleBreakpoints(breakpoint, 'default');
    }
  });
}

function handleBreakpoints(breakpoint, layout) {
  const $prodGridLayout = $('.product-view-layout');
  $prodGridLayout.removeClass('active');

  if (breakpoint.matches) {
    // smaller devices
    if (layout == 'default') {
      $('.product-view-layout[data-layout=2]').addClass('active');
      setLayout(2);
    } else {
      const colLayout = layout == 4 ? 2 : layout;
      $(`.product-view-layout[data-layout=${colLayout}]`).addClass('active');
      setLayout(colLayout);
    }
  } else {
    // desktop devices
    if (layout == 'default') {
      $('.product-view-layout[data-layout=4]').addClass('active');
      setLayout(4);
    } else {
      const colLayout = layout == 1 ? 2 : layout;
      $(`.product-view-layout[data-layout=${colLayout}]`).addClass('active');
      setLayout(colLayout);
    }
  }
}

export default function () {
  const $prodGridLayout = $('.product-view-layout');
  const cookie = new Cookie();
  const saveLayout =
    cookie.getCookie('grid-layout') != undefined
      ? parseInt(cookie.getCookie('grid-layout'))
      : null;
  const breakpoint = window.matchMedia('(max-width: 767px)');

  if (saveLayout != null) {
    handleBreakpoints(breakpoint, saveLayout);
  } else {
    handleBreakpoints(breakpoint, 'default');
  }
  handleResponsive();

  $prodGridLayout.on('click', function () {
    $prodGridLayout.removeClass('active');
    $(this).addClass('active');

    const layout = parseInt($(this).attr('data-layout'));
    setLayout(layout);

    cookie.setCookie('grid-layout', layout, 'no-expiry');
  });
}
